import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';

interface AutoFocusPluginProps {
  autoFocus?: boolean;
}

export function AutoFocusPlugin({ autoFocus }: AutoFocusPluginProps) {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (autoFocus) {
      // Small delay to ensure the editor is ready
      setTimeout(() => {
        editor.focus();
      }, 100);
    }
  }, [editor, autoFocus]);

  return null;
}
